import { useMutation } from 'react-query';
import { mutateSharesPercentage } from '~/api/shareholder';
import { Sharepercentage, SharepercentageRes } from '~/types/SharesPercentage';
import { ApiError } from '~/types/ApiError';

export const useMutateSharesPercentage = () => {
  return useMutation<SharepercentageRes, ApiError, Sharepercentage>(mutateSharesPercentage);
};